"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f101 = void 0;
exports.f101 = {
    "eaa": [
        "Latn"
    ],
    "ebc": [
        "Latn"
    ],
    "ebg": [
        "Latn"
    ],
    "ebk": [
        "Latn"
    ],
    "ebo": [
        "Latn"
    ],
    "ebr": [
        "Latn"
    ],
    "ebu": [
        "Latn"
    ],
    "ecr": [
        "Grek"
    ],
    "ecs": [
        "Zxxx"
    ],
    "ecy": [
        "Cprt"
    ],
    "ee": [
        "Latn",
        "Brai"
    ],
    "eee": [
        "Zyyy"
    ],
    "efa": [
        "Latn"
    ],
    "efe": [
        "Latn"
    ],
    "efi": [
        "Latn"
    ],
    "ega": [
        "Latn"
    ],
    "egl": [
        "Latn"
    ],
    "ego": [
        "Latn"
    ],
    "egy": [
        "Egyp"
    ],
    "ehs": [
        "Zxxx"
    ],
    "ehu": [
        "Latn"
    ],
    "eip": [
        "Latn"
    ],
    "eit": [
        "Latn"
    ],
    "eiv": [
        "Latn"
    ],
    "eja": [
        "Latn"
    ],
    "eka": [
        "Latn"
    ],
    "ekc": [
        "Latn"
    ],
    "eke": [
        "Latn"
    ],
    "ekg": [
        "Latn"
    ],
    "eki": [
        "Latn"
    ],
    "ekl": [
        "Latn"
    ],
    "ekm": [
        "Latn"
    ],
    "eko": [
        "Latn",
        "Arab"
    ],
    "ekp": [
        "Latn"
    ],
    "ekr": [
        "Latn"
    ],
    "eky": [
        "Kali"
    ],
    "el": [
        "Grek",
        "Brai",
        "Cyrl"
    ],
    "ele": [
        "Latn"
    ],
    "elh": [
        "Zyyy"
    ],
    "eli": [
        "Zyyy"
    ],
    "elk": [
        "Latn"
    ],
    "elm": [
        "Latn"
    ],
    "elo": [
        "Latn"
    ],
    "elu": [
        "Latn"
    ],
    "elx": [
        "Zyyy"
    ],
    "ema": [
        "Latn"
    ],
    "emb": [
        "Latn"
    ],
    "eme": [
        "Latn"
    ],
    "emg": [
        "Deva"
    ],
    "emi": [
        "Latn"
    ],
    "emm": [
        "Latn"
    ],
    "emn": [
        "Latn"
    ],
    "emp": [
        "Latn"
    ],
    "emq": [
        "Zyyy"
    ],
    "ems": [
        "Latn",
        "Cyrl"
    ],
    "emu": [
        "Deva"
    ],
    "emw": [
        "Latn"
    ],
    "emx": [
        "Latn"
    ],
    "emy": [
        "Maya"
    ],
    "emz": [
        "Latn"
    ],
    "en": [
        "Latn",
        "Brai",
        "Dsrt",
        "Dupl",
        "Shaw"
    ],
    "ena": [
        "Latn"
    ],
    "enb": [
        "Latn"
    ],
    "enc": [
        "Latn"
    ],
    "end": [
        "Latn"
    ],
    "enf": [
        "Cyrl"
    ],
    "enh": [
        "Cyrl"
    ],
    "enl": [
        "Latn"
    ],
    "enm": [
        "Latn"
    ],
    "enn": [
        "Latn"
    ],
    "eno": [
        "Latn"
    ],
    "enq": [
        "Latn"
    ],
    "enr": [
        "Latn"
    ],
    "enu": [
        "Zyyy"
    ],
    "env": [
        "Latn"
    ],
    "enw": [
        "Latn"
    ],
    "enx": [
        "Latn"
    ],
    "eo": [
        "Latn"
    ],
    "eot": [
        "Latn"
    ],
    "epi": [
        "Latn"
    ],
    "era": [
        "Zyyy"
    ],
    "erg": [
        "Latn"
    ],
    "erh": [
        "Latn"
    ],
    "eri": [
        "Latn"
    ],
    "erk": [
        "Latn"
    ],
    "ero": [
        "Zyyy"
    ],
    "err": [
        "Latn"
    ],
    "ers": [
        "Zzzz"
    ],
    "ert": [
        "Latn"
    ],
    "erw": [
        "Latn"
    ],
    "es": [
        "Latn",
        "Brai",
        "Dupl"
    ],
    "ese": [
        "Latn"
    ],
    "esg": [
        "Deva",
        "Gonm",
        "Telu"
    ],
    "esh": [
        "Arab"
    ],
    "esi": [
        "Latn"
    ],
    "esl": [
        "Zxxx"
    ],
    "esm": [
        "Latn"
    ],
    "esn": [
        "Zxxx"
    ],
    "eso": [
        "Zxxx"
    ],
    "esq": [
        "Zyyy"
    ],
    "ess": [
        "Latn",
        "Cyrl"
    ],
    "esu": [
        "Latn"
    ],
    "esy": [
        "Latn",
        "Zzzz"
    ],
    "et": [
        "Latn",
        "Brai"
    ],
    "etb": [
        "Latn"
    ],
    "etc": [
        "Zyyy"
    ],
    "eth": [
        "Zxxx"
    ],
    "etn": [
        "Latn"
    ],
    "eto": [
        "Latn"
    ],
    "etr": [
        "Latn"
    ],
    "ets": [
        "Latn"
    ],
    "ett": [
        "Ital",
        "Latn"
    ],
    "etu": [
        "Latn"
    ],
    "etx": [
        "Latn"
    ],
    "etz": [
        "Latn"
    ],
    "eu": [
        "Latn"
    ],
    "eve": [
        "Cyrl",
        "Cyrs"
    ],
    "evh": [
        "Latn"
    ],
    "evn": [
        "Cyrl",
        "Latn",
        "Mong"
    ],
    "ewo": [
        "Latn"
    ],
    "ext": [
        "Latn"
    ],
    "eya": [
        "Latn"
    ],
    "eyo": [
        "Latn"
    ],
    "eza": [
        "Latn"
    ],
    "eze": [
        "Latn"
    ]
};
